import {LOCALE_CATEGORIES} from "@/assets/locales/categories";
import {getClientListRouteLocation} from "@/domains/-coachee/-list/routes";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import router from "@/router";
import {JourneyId, PersonId, WorkspaceId} from "@/sdk.ts";
import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";

const pageHeaderConfig = {
  showHome: true,
  breadcrumb: [{
    label: 'My clients',
    route: () => {
      if (router && router.currentRoute && router.currentRoute.value)
        return getClientListRouteLocation(parseInt(router.currentRoute.value.params.workspaceId as string, 10))
      return undefined
    }
  }, {
    label: 'Client'
  }]
}

export const COACHEE_OVERVIEW_ROUTE_NAME = 'coachee_overview';

export function isCoacheeOverviewRoute(router: Router): boolean {
  return router.currentRoute.value.name === COACHEE_OVERVIEW_ROUTE_NAME
}

export function getCoacheeOverviewRouteRecord(): RouteRecordRaw {
  return {
    name: 'coachee_overview',
    path: '/workspace/:workspaceId/coachee/:personId',
    component: customAsyncComponent(async () => import('./views/CoacheeView.vue')),
    meta: {
      hasNav: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.JOURNEY,
        LOCALE_CATEGORIES.COACHEES,
        LOCALE_CATEGORIES.LEXICON,
        LOCALE_CATEGORIES.ERRORS
      ],
      pageHeader: pageHeaderConfig
    },
  }
}

export function getCoacheeOverviewRouteLocation(workspaceId: WorkspaceId, personId: PersonId): RouteLocationRaw {
  return {name: 'coachee_overview', params: {workspaceId, personId}}
}

export function getCoacheeOverviewRouteParams(router: Router): { workspaceId: WorkspaceId; personId: PersonId; } {
  const route = router.currentRoute.value;
  return {
    workspaceId: parseInt(route.params.workspaceId as string, 10),
    personId: route.params.personId as string,
  }
}

export function getCoacheeJourneyRouteRecord(): RouteRecordRaw {
  return {
    name: 'coachee_journey',
    path: '/workspace/:workspaceId/coachee/:personId/journey/:journeyId',
    component: customAsyncComponent(async () => import('./views/CoacheeView.vue')),
    meta: {
      hasNav: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.JOURNEY,
        LOCALE_CATEGORIES.COACHEES,
        LOCALE_CATEGORIES.LEXICON
      ],
      pageHeader: pageHeaderConfig
    },
  }
}

export function getCoacheeJourneyRouteLocation(workspaceId: WorkspaceId, personId: PersonId, journeyId: JourneyId): RouteLocationRaw {
  return {name: 'coachee_journey', params: {workspaceId, personId, journeyId}}
}

export function getCoacheeJourneyRouteParams(router: Router): {
  workspaceId: WorkspaceId;
  personId: PersonId;
  journeyId: JourneyId
} {
  const route = router.currentRoute.value;
  return {
    workspaceId: parseInt(route.params.workspaceId as string, 10),
    personId: route.params.personId as string,
    journeyId: route.params.journeyId as string,
  }
}